<div class="user-card inner-shadow" [routerLink]="redirectUrl">
    <div class="details">
      <div class="title text-left">{{data.name}}</div>
      <div class="detail">
        <div class="desc">{{data.brand}} {{data.model}}</div>
        <div class="desc">{{data.serial_number}}</div>
        <!-- <div class="desc">{{data.email}}</div>
        <div class="date">{{data.created_at | date}}</div> -->
      </div>
    </div>
    <div class="avatar" [style.backgroundImage]="background_image"></div>
  </div>